/** @format */

import { ThunkDispatch } from "@reduxjs/toolkit";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useGetFullResourceQuery } from "../../app/services/resource/resourcesApi";
import { usePrintUserResourceQuery } from "../../app/services/userResource/userResourcesApi";
import BLSpinner from "../../assets/animations/BLSpinner/BLSpinner";
import { setIsEditable } from "../editable/editableSlice";
import ErrorPage from "../errorPage/ErrorPage";
import { useLocale } from "../i18n/hooks";
import PrintableAppUI from "./PrintableAppUI";
import { setIsPrintable } from "./printableSlice";

const UserPrintableApp: React.FC = () => {
  const { resourceId, userId, copy } = useParams();
  const locale = useLocale();
  const { data, isLoading, error } = usePrintUserResourceQuery(
    resourceId !== undefined &&
      userId !== undefined &&
      copy !== undefined &&
      locale !== undefined
      ? { code: resourceId, copy, locale, email: userId }
      : skipToken,
  );

  return isLoading ? (
    <BLSpinner
      className="position-absolute top-50 start-50 translate-middle"
      size="3rem"
    />
  ) : data ? (
    <PrintableAppUI resource={data} />
  ) : (
    <ErrorPage
      statusCode={
        typeof (error as any).status === "number" ? (error as any).status : 500
      }
      actions={["report"]}
    />
  );
};

const ResourcePrintableApp: React.FC = () => {
  const { resourceId } = useParams();
  const { data, isLoading, error } = useGetFullResourceQuery(
    resourceId !== undefined ? { code: resourceId } : skipToken,
  );

  return isLoading ? (
    <BLSpinner
      className="position-absolute top-50 start-50 translate-middle"
      size="3rem"
    />
  ) : data ? (
    <PrintableAppUI resource={data} />
  ) : (
    <ErrorPage
      statusCode={
        typeof (error as any).status === "number" ? (error as any).status : 500
      }
      actions={["report"]}
    />
  );
};

const PrintableApp: React.FC = () => {
  const { userId } = useParams();
  const dispatch = useDispatch<ThunkDispatch<any, string, any>>();
  useEffect(() => {
    dispatch(setIsPrintable(true));
    dispatch(setIsEditable(false));
  }, [dispatch]);

  return userId === undefined ? <ResourcePrintableApp /> : <UserPrintableApp />;
};

export default PrintableApp;
